module.exports = __webpack_public_path__ + "img/jaoc_pizzagame_black-bake.375554cb.png";